export default {
  from: '에서',
  perLesson: '/레슨',
}
